module.exports = __webpack_public_path__ + "static/media/backend.95bf5347.svg";